var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 11H12C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V28C11 28.2652 11.1054 28.5196 11.2929 28.7071C11.4804 28.8946 11.7348 29 12 29H20.615V22.04H18.277V19.315H20.615V17.315C20.615 14.99 22.035 13.723 24.115 13.723C24.814 13.721 25.514 13.757 26.21 13.83V16.25H24.775C23.647 16.25 23.427 16.788 23.427 17.575V19.31H26.124L25.774 22.035H23.426V29H28C28.2652 29 28.5196 28.8946 28.7071 28.7071C28.8946 28.5196 29 28.2652 29 28V12C29 11.7348 28.8946 11.4804 28.7071 11.2929C28.5196 11.1054 28.2652 11 28 11Z",
    fill: "#4254EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c8e2725af554fd0aeb0f042cf17ce284.svg";
export { ForwardRef as ReactComponent };